import {
  AssessmentGroupListFragmentFragment,
  ComplianceProgramStep,
  OrganizationTalentIndicatorFragment,
} from "types/graphql-schema";

import EngagementSurveyStep from "../steps/engagement-survey-step";
import PeerAssessmentStep from "../steps/peer-assessment-step";
import SelfManagerAssessmentStep from "../steps/self-manager-assessment-step";
import UpwardAssessmentStep from "../steps/upward-assessment-step";
import { ProgramForm, ProgramFormStep } from "../types";

const ProgramFormQuestions = ({
  proposedComplianceProgram,
  canUpdate,
  talentIndicatorData,
  availableAssessmentGroups,
  onAssessmentGroupCreated,
  onAssessmentGroupArchived,
  onAddOrUpdateStep,
}: {
  canUpdate: boolean;
  proposedComplianceProgram: ProgramForm;
  talentIndicatorData?: OrganizationTalentIndicatorFragment[];
  availableAssessmentGroups: AssessmentGroupListFragmentFragment[];
  onAssessmentGroupCreated: (
    newAssessmentGroup: AssessmentGroupListFragmentFragment,
  ) => void;
  onAssessmentGroupArchived: (assessmentGroupId: number) => void;
  onAddOrUpdateStep: (step: ProgramFormStep) => void;
}) => {
  const activeSteps = proposedComplianceProgram.steps.map(
    ({ stepType }) => stepType,
  );
  return (
    <div className="flex flex-col gap-8">
      {activeSteps.includes(ComplianceProgramStep.SelfReview) &&
        activeSteps.includes(ComplianceProgramStep.DownwardReview) && (
          <SelfManagerAssessmentStep
            proposedComplianceProgram={proposedComplianceProgram}
            canUpdate={canUpdate}
            talentIndicatorData={talentIndicatorData}
            availableAssessmentGroups={availableAssessmentGroups}
            onAssessmentGroupCreated={onAssessmentGroupCreated}
            onAssessmentGroupArchived={onAssessmentGroupArchived}
            onAddOrUpdateStep={onAddOrUpdateStep}
          />
        )}

      {activeSteps.includes(ComplianceProgramStep.UpwardReview) && (
        <UpwardAssessmentStep
          proposedComplianceProgram={proposedComplianceProgram}
          canUpdate={canUpdate}
          talentIndicatorData={talentIndicatorData}
          onAddOrUpdateStep={onAddOrUpdateStep}
          availableAssessmentGroups={availableAssessmentGroups}
          onAssessmentGroupCreated={onAssessmentGroupCreated}
          onAssessmentGroupArchived={onAssessmentGroupArchived}
        />
      )}

      {activeSteps.includes(ComplianceProgramStep.PeerReview) && (
        <PeerAssessmentStep
          proposedComplianceProgram={proposedComplianceProgram}
          canUpdate={canUpdate}
          onAddOrUpdateStep={onAddOrUpdateStep}
          availableAssessmentGroups={availableAssessmentGroups}
          onAssessmentGroupCreated={onAssessmentGroupCreated}
          onAssessmentGroupArchived={onAssessmentGroupArchived}
        />
      )}

      {activeSteps.includes(ComplianceProgramStep.EngagementSurvey) && (
        <EngagementSurveyStep
          proposedComplianceProgram={proposedComplianceProgram}
          canUpdate={canUpdate}
          onAddOrUpdateStep={onAddOrUpdateStep}
          availableAssessmentGroups={availableAssessmentGroups}
          onAssessmentGroupCreated={onAssessmentGroupCreated}
          onAssessmentGroupArchived={onAssessmentGroupArchived}
        />
      )}
    </div>
  );
};

export default ProgramFormQuestions;
